import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Checkbox } from 'dibs-elements/exports/Checkbox';
import { Input } from 'dibs-elements/exports/Input';
import { Spinner } from 'dibs-elements/exports/Spinner';
import { Button } from 'dibs-elements/exports/Button';

import styles from './styles.scss';

class CallDealerForm extends PureComponent {
    constructor(props) {
        super(props);
        this.onNameChange = this.onNameChange.bind(this);
        this.onPhoneNumberChange = this.onPhoneNumberChange.bind(this);
        this.onCountryCodeChange = this.onCountryCodeChange.bind(this);
        this.onFormSubmit = this.onFormSubmit.bind(this);
    }

    onNameChange(e) {
        this.props.setName(e.target.value);
    }

    onPhoneNumberChange(e) {
        this.props.setPhoneNumber(e.target.value);
    }

    onCountryCodeChange(e) {
        this.props.setCountryCode(e.target.value);
    }

    onFormSubmit(e) {
        e.preventDefault();
        this.props.onSubmit();
    }

    render() {
        const {
            showNameField,
            showAllowCallbackPrompt,
            name,
            phoneNumber,
            countryCode,
            phoneCallbackEnabled,
            submitting,
            error,
            setPhoneCallbackEnabled,
        } = this.props;

        const submitDisabled =
            submitting || (!name && showNameField) || !phoneNumber || !countryCode;

        const inputPhoneNumber = (
            <FormattedMessage
                id="dc.buyerInitiateCall.nonTradeInputPhoneNumber"
                defaultMessage="Your number (no extensions)"
            />
        );

        return (
            <form className={styles.form} onSubmit={this.onFormSubmit}>
                {error ? <div className={styles.error}>{error}</div> : null}
                <div className={styles.inputsRow}>
                    <div className={styles.countryCode}>
                        <Input
                            dataTn="your-contry-code"
                            onChange={this.onCountryCodeChange}
                            label={
                                <FormattedMessage
                                    id="dc.buyerInitiateCall.inputCountryCode"
                                    defaultMessage="Country Code"
                                />
                            }
                            value={countryCode}
                            disabled={submitting}
                            leftDecorator={'+'}
                            leftDecoratorClass={styles.leftDecorator}
                        />
                    </div>
                    <div className={styles.phoneNumber}>
                        <Input
                            dataTn="your-number"
                            onChange={this.onPhoneNumberChange}
                            label={inputPhoneNumber}
                            value={phoneNumber}
                            disabled={submitting}
                        />
                    </div>
                </div>
                {showNameField ? (
                    <div className={styles.inputsRow}>
                        <div className={styles.name}>
                            <Input
                                dataTn="your-name"
                                onChange={this.onNameChange}
                                label={
                                    <FormattedMessage
                                        id="dc.buyerInitiateCall.inputName"
                                        defaultMessage="Your Name"
                                    />
                                }
                                value={name}
                                disabled={submitting}
                            />
                        </div>
                    </div>
                ) : null}
                {showAllowCallbackPrompt ? (
                    <div className={styles.allowCallbackPromptContainer}>
                        <Checkbox
                            name="showAllowCallbackPrompt"
                            onChange={setPhoneCallbackEnabled}
                            dataTn="allow-callback-prompt"
                            label={
                                <FormattedMessage
                                    id="dc.buyerInitiateCall.callbackPrompt"
                                    defaultMessage="Allow seller to call you back"
                                />
                            }
                            labelClass={styles.checkboxLabel}
                            checked={phoneCallbackEnabled}
                        />
                        <span className={styles.allowCallbackDetails}>
                            <FormattedMessage
                                id="dc.buyerInitiateCall.callbackDetails"
                                defaultMessage="We will not share your number with the seller."
                            />
                        </span>
                    </div>
                ) : null}
                <Button
                    className={styles.submit}
                    disabled={submitDisabled}
                    size="large"
                    dataTn="connect-call"
                >
                    {submitting && <Spinner dark containerClass={styles.inlineSpinner} />}
                    <FormattedMessage
                        id="dc.buyerInitiateCall.submitCall"
                        defaultMessage="Call me"
                    />
                </Button>
                <p className={styles.footer}>
                    <FormattedMessage
                        id="dc.buyerInitiateCall.formFooter"
                        defaultMessage="International calling rates will not apply. We will not share your number with the seller."
                    />
                </p>
            </form>
        );
    }
}

CallDealerForm.propTypes = {
    showNameField: PropTypes.bool,
    showAllowCallbackPrompt: PropTypes.bool,
    name: PropTypes.string,
    phoneNumber: PropTypes.string,
    countryCode: PropTypes.string,
    phoneCallbackEnabled: PropTypes.bool,
    error: PropTypes.node,
    submitting: PropTypes.bool,
    setName: PropTypes.func,
    setPhoneNumber: PropTypes.func.isRequired,
    setCountryCode: PropTypes.func.isRequired,
    setPhoneCallbackEnabled: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
};

CallDealerForm.defaultProps = {
    setName: () => {},
};

export default CallDealerForm;
